import { el, setChildren, setAttr } from 'redom';

import Tooltip from 'generics/components/tooltip/native';

class NativeHorizontalToggle {

  constructor(configuration) {

    if (typeof configuration.value !== 'boolean') {
      throw new Error('Invalid "value" property. It must be present & must be of type boolean');
    }

    if (typeof configuration.onChange !== 'function') {
      throw new Error('"onChange" event handler is not provided!');
    }

    this.value = configuration.value;
    this.onChange = configuration.onChange;
    this.sizeClass = configuration.size || '';
    this.disabled = configuration.disabled;
    this.tooltipOptions = configuration.tooltip;

    this.toggleButton = null;
    this.tooltip = null;

    this.label = this.determineLabel(configuration.label);
    this.intializeToggleButton(configuration);
    this.tryInitializeTooltip();

    this.children = [this.label, this.toggleButton];

    if (configuration.buttonFirst === true) {
      this.children = this.children.reverse();
    }

    this.el = el('button.horizontal-toggle-main', {
      disabled: this.disabled,
      class: this.sizeClass,
      onclick: this.handleToggleButtonClick.bind(this)
    }, this.children);

  }

  determineLabel(label) {

    if (typeof label === 'string') {
      return el('label.field-label', label);
    }

    return label;

  }

  getTooltipContent() {

    const content = this.tooltipOptions.content;
    const contentType = typeof content;

    if (contentType === 'function') {
      return content(this.value);
    } else {
      return content;
    }

  }

  intializeToggleButton(configuration) {

    this.toggleButton = el('.toggle-button', {
      type: 'button'
    });

    this.updateToggleButtonDisplayState();

  }

  tryInitializeTooltip() {

    if (this.tooltipOptions === void 0) {
      return;
    }

    this.tooltip = new Tooltip({
      content: this.getTooltipContent(),
      target: this.toggleButton,
      placement: 'top',
      offset: 5,
      placeOnCenter: true
    });

  }

  updateToggleButtonDisplayState() {

    const toggleButtonClassList = this.toggleButton.classList;

    toggleButtonClassList.remove('active', 'inactive');

    if (this.value === true) {
      toggleButtonClassList.add('active');
    } else {
      toggleButtonClassList.add('inactive');
    }

    setAttr(this.toggleButton, {
      disabled: this.disabled
    });

  }

  handleToggleButtonClick() {

    this.toggleValue();

  }

  toggleValue() {

    if (this.value === true) {
      this.value = false;
    } else {
      this.value = true;
    }

    this.updateToggleButtonDisplayState();

    this.onChange(this.value);

  }

  updateTooltip() {

    if (this.tooltip === null) {
      return;
    }

    this.tooltip.update({
      content: this.getTooltipContent()
    });

  }

  update(label, value, disabled = false, tooltipOptions = this.tooltipOptions) {

    this.label = el('label.field-label', label);
    this.value = value;
    this.disabled = disabled;
    this.tooltipOptions = tooltipOptions;

    setChildren(this.el, [this.label, this.toggleButton]);

    this.updateToggleButtonDisplayState();
    this.updateTooltip();

  }

  updateValue(value) {

    this.value = value;

    this.updateToggleButtonDisplayState();

  }

  enable() {

    this.value = true;
    this.disabled = false;

    this.updateToggleButtonDisplayState();

  }

  disable() {

    this.value = false;
    this.disabled = true;

    this.updateToggleButtonDisplayState();

  }
  onunmount() {

    // I see no reason for tooltip to be null when onunmount is called.
    // But, it is happening & I do not have time.
    // So, checking for null.
    if (this.tooltip === null) {
      return;
    }

    this.tooltip.destroy();
    this.tooltip = null;

  }

}

export default NativeHorizontalToggle;